<template>
<div id="ed">
  <el-tiptap :extensions="extensions" v-model="content" 
  @onUpdate="updatedContent" placeholder="Write something ..."/>
</div>
</template>

<script>
import {
  // all extensions
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Link,
  Image,
  Blockquote,
  ListItem,
  BulletList, // use with ListItem
  OrderedList, // use with ListItem
  TodoItem,
  TodoList, // use with TodoItem
  TextAlign,
  Indent,
  HorizontalRule,
  HardBreak,
  History,
  LineHeight,
  Iframe,
  CodeBlock,
  TrailingNode,
  Table, // use with TableHeader, TableCell, TableRow
  TableHeader,
  TableCell,
  TableRow,
  FormatClear,
  TextColor,
  TextHighlight,
  Preview,
  Print,
  Fullscreen,
  CodeView,
  // SelectAll,
} from "element-tiptap";

import codemirror from "codemirror";
import "codemirror/lib/codemirror.css"; // import base style
import "codemirror/mode/xml/xml.js"; // language
import "codemirror/addon/selection/active-line.js"; // require active-line.js
import "codemirror/addon/edit/closetag.js"; // autoCloseTags

import 'element-ui/lib/theme-chalk/index.css';
import 'element-tiptap/lib/index.css';

export default {
  name: "Editor",
  props: {
    initialContent: {
      type: String,
      required: false,
      default: '<em>editable text</em>',
    },
    loadedContent: {
      type: String,
      required: false,
      default: '<em>editable text, please change</em>',
    },
  },
  data () {
    return {
      html: '',
      json: '',
      extensions: [
        new Doc(),
        new Text(),
        new Paragraph(),
        new Heading({ level: 5 }),
        new Bold({ bubble: true }),
        new Underline({ bubble: true }),
        new Italic({ bubble: true }),
        new Strike({ bubble: true }),
        new Link({ bubble: true }),
        new Image(),
        new Blockquote(),
        new TextAlign(),
        new ListItem(),
        new BulletList({ bubble: true }),
        new OrderedList({ bubble: true }),
        new TodoItem(),
        new TodoList(),
        new Indent({ bubble: true }),
        new HardBreak(),
        new HorizontalRule({ bubble: true }),
        new Fullscreen(),
        new CodeView({
          codemirror,
          codemirrorOptions: {
            styleActiveLine: true,
            autoCloseTags: true
          }
        }),
        new History(),
        new Print(),
        new LineHeight(),
        new Iframe(),
        new CodeBlock({ bubble: true }),
        new TrailingNode(),
        new Table({ bubble: true }),
        new TableHeader({ bubble: true }),
        new TableCell({ bubble: true }),
        new TableRow({ bubble: true }),
        new FormatClear(),
        new TextColor({ bubble: true }),
        new TextHighlight({ bubble: true }),
        new Preview(),
        // new SelectAll()
      ],
      content: this.initialContent
    }
  },
  watch: {
    loadedContent: {
      immediate: true,
      deep: true,
      handler (val) {
        console.log('Updating content')
        this.content = val
      }
    }
  },
  methods: {
    updatedContent(val) {
      // console.log(val)
      this.$emit('update', val)
    }
  },
  beforeDestroy() {
  },
  created() {
  },
  mounted () {
    this.content = this.initialContent
  }
};
</script>
<style scoped>
#ed {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 40px;
}

header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  width: 100%;
}
</style>